export const earlyAccessEn = {
  'earlyAccess.title': 'Request early access',
  'earlyAccess.subtitle':
    'Tell us who you are and what you want Workerize to help you unlock. We will use this to manage launch access only.',
  'earlyAccess.field.name': 'Name',
  'earlyAccess.field.email': 'Email',
  'earlyAccess.field.interestedAs': 'Interested as',
  'earlyAccess.field.company': 'Company',
  'earlyAccess.field.role': 'Role',
  'earlyAccess.field.useCase': 'Use case',
  'earlyAccess.field.consent':
    'I agree to be contacted about Workerize early access.',
  'earlyAccess.option.candidate': 'Candidate',
  'earlyAccess.option.employer': 'Employer',
  'earlyAccess.option.company': 'Company',
  'earlyAccess.option.partner': 'Partner',
  'earlyAccess.option.other': 'Other',
  'earlyAccess.placeholder.name': 'Your full name',
  'earlyAccess.placeholder.email': 'you@example.com',
  'earlyAccess.placeholder.company': 'Company or organization',
  'earlyAccess.placeholder.role': 'Your current role',
  'earlyAccess.placeholder.useCase':
    'What should Workerize help you understand or improve?',
  'earlyAccess.submit': 'Request access',
  'earlyAccess.submitting': 'Sending request',
  'earlyAccess.success.title': 'Request received',
  'earlyAccess.success.body':
    'Thanks. Your early access request has been received. No invite has been sent yet.',
  'earlyAccess.error.title': 'Request could not be sent',
  'earlyAccess.error.body':
    'Please check your details and try again. If the problem continues, try again later.',
  'earlyAccess.validation.name': 'Enter your name.',
  'earlyAccess.validation.email': 'Enter a valid email address.',
  'earlyAccess.validation.interestedAs': 'Choose how you are interested in Workerize.',
  'earlyAccess.validation.consent': 'Please confirm we may contact you about early access.',
  'earlyAccess.haveAccount': 'Already have an account?',
  'earlyAccess.signIn': 'Sign in',
  'earlyAccess.fromGoogle.notice':
    "We couldn't find a Workerize account for that Google email yet. Workerize is invite-only during early access — join the waitlist below and we'll be in touch.",
} as const;
